import { Grid, Typography } from '@material-ui/core'
import React from 'react'

const GridTitle = ({ title }) => {
    return (
        <Grid item>
            <Typography variant="h5">
                {title}
            </Typography>
        </Grid>
    )
}


export default GridTitle
